"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AddGranteeBase = void 0;
var tslib_1 = require("tslib");
// (C) 2021-2022 GoodData Corporation
var react_1 = tslib_1.__importStar(require("react"));
var react_intl_1 = require("react-intl");
var Button_1 = require("../../../Button");
var ConfirmDialogBase_1 = require("../../ConfirmDialogBase");
var AddGranteeContent_1 = require("./AddGranteeContent");
var ContentDivider_1 = require("./ContentDivider");
var BackButton = function (props) {
    var onBackClick = props.onClick;
    return (react_1.default.createElement(Button_1.Button, { value: "", className: "gd-button-primary gd-button-icon-only gd-icon-navigateleft gd-share-dialog-header-back-button s-share-dialog-navigate-back", onClick: onBackClick }));
};
/**
 * @internal
 */
exports.AddGranteeBase = function (props) {
    var appliedGrantees = props.appliedGrantees, addedGrantees = props.addedGrantees, currentUserRef = props.currentUserRef, isDirty = props.isDirty, onCancel = props.onCancel, onSubmit = props.onSubmit, onBackClick = props.onBackClick, onAddUserOrGroups = props.onAddUserOrGroups, onDelete = props.onDelete;
    var intl = react_intl_1.useIntl();
    var backButtonRenderer = react_1.useCallback(function () {
        return react_1.default.createElement(BackButton, { onClick: onBackClick });
    }, [onBackClick]);
    return (react_1.default.createElement(ConfirmDialogBase_1.ConfirmDialogBase, { className: "gd-share-dialog gd-share-dialog-add-users s-gd-share-add-grantees", displayCloseButton: true, isPositive: true, isSubmitDisabled: !isDirty, headline: intl.formatMessage({ id: "shareDialog.share.grantee.add.info" }), cancelButtonText: intl.formatMessage({ id: "cancel" }), submitButtonText: intl.formatMessage({ id: "shareDialog.share.grantee.share" }), onCancel: onBackClick, onSubmit: onSubmit, onClose: onCancel, headerLeftButtonRenderer: backButtonRenderer },
        react_1.default.createElement(AddGranteeContent_1.AddGranteeContent, { currentUserRef: currentUserRef, addedGrantees: addedGrantees, appliedGrantees: appliedGrantees, onAddUserOrGroups: onAddUserOrGroups, onDelete: onDelete }),
        react_1.default.createElement(ContentDivider_1.ContentDivider, null)));
};
//# sourceMappingURL=AddGranteeBase.js.map